import { Button } from "../../../../shared/ui";

import type { FC } from "react";
import { getRouteVacancies } from "../../../../shared/constants/routes";

import styles from "./NavigationVacancies.module.scss";

interface NavigationVacanciesProps {
    onClick?: () => void;
}

export const NavigationVacancies: FC<NavigationVacanciesProps> = ({ onClick }) => (
    <Button as="link" to={getRouteVacancies()} className={styles.button} onClick={onClick}>
        Все вакансии
    </Button>
);
